<template>
  <div class="container">
    <div class="head">
      <img src="@/assets/back.png" style="padding: 10px" alt="返回" width="21" height="21" @click="go">
      <div>管理手机号码</div>
      <div style="margin-right: 10px;color: #FE003B">管理</div>
    </div>
    <div>
      <div class="phone" v-for="i in 3">
        <div class="phones">13259622239</div>
        <div class="phoneHint">微信绑定号码</div>
      </div>
      <div class="addphoney" @click="addPhone">
        <div class="addtest">添加其他号码</div>
        <img src="@/assets/addgo.png" style="padding: 10px" width="18" height="18" @click="addPhone">
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "phone",
        methods:{
          go(){
            this.$router.go(-1);
          },
          addPhone(){
            this.$router.push("/addPhone")
          }
        }
    }
</script>

<style lang="less" scoped>
  .container{
    .head{
      background-color: #F3F3F3;
      height:44px;
      line-height: 44px;
      opacity:1;
      display: flex;
      justify-content: space-between;
    }
    .phone{
      padding: 12px;
      display: flex;
      .phones{
        width:106px;
        height:22px;
        font-size:16px;
        font-family:PingFang SC;
        font-weight:500;
        line-height:22px;
        color:#333333;
        opacity:1;
      }
      phoneHint{
        width:96px;
        height:22px;
        font-size:16px;
        font-family:PingFang SC;
        font-weight:500;
        line-height:22px;
        color:#C7C7C7;
        opacity:1;
      }
    }
    .addphoney{
      display: flex;
      justify-content: space-between;
      padding-left: 15px;
      padding-right: 15px;
      border-bottom: #F3F3F3;
      .addtest{
        width:96px;
        font-size:16px;
        font-family:PingFang SC;
        font-weight:400;
        line-height:40px;
        color:rgba(51,51,51,1);
        opacity:1;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/login/phone.vue